var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpielLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 541,
    viewBox: "0 0 686 541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_184)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7333 266.69C20.4756 266.69 0 287.158 0 312.408V495.282C0 520.532 20.4756 541 45.7333 541H82.32C99.264 541 114.056 531.788 121.958 518.101C81.0059 516.797 48.2083 483.198 48.2083 441.944C48.2083 399.861 82.3342 365.746 124.43 365.746H128.053V312.408C128.053 287.158 107.578 266.69 82.32 266.69H45.7333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.681 266.69C578.422 266.69 557.947 287.158 557.947 312.408V365.746H561.569C603.667 365.746 637.792 399.861 637.792 441.944C637.792 483.198 604.995 516.797 564.044 518.101C571.945 531.788 586.736 541 603.681 541H640.267C665.526 541 686.001 520.532 686.001 495.282V312.408C686.001 287.158 665.526 266.69 640.267 266.69H603.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.519 396.225H126.528C101.27 396.225 80.7949 416.694 80.7949 441.944C80.7949 467.193 101.27 487.662 126.528 487.662H562.519C587.777 487.662 608.253 467.193 608.253 441.944C608.253 416.694 587.777 396.225 562.519 396.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.144 101.952L207.99 6.73425C192.462 -4.1242 171.059 -0.351406 160.183 15.161C149.307 30.6733 153.078 52.0512 168.606 62.9096L259.518 126.487H147.872C101.566 126.487 64.0273 164.013 64.0273 210.304V237.735H82.3207C99.48 237.735 115.315 243.403 128.054 252.969V228.592C128.054 207.55 145.117 190.493 166.165 190.493H352.147C373.195 190.493 390.258 207.55 390.258 228.592V364.223H527.458V313.932C527.458 271.85 561.585 237.735 603.681 237.735H621.974V210.304C621.974 164.013 584.436 126.487 538.13 126.487H428.772L520.448 62.3758C535.974 51.5174 539.745 30.1395 528.87 14.6271C517.995 -0.885266 496.59 -4.65804 481.064 6.20041L344.144 101.952Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 686,
    height: 541,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpielLogoWhite);
export default __webpack_public_path__ + "static/media/SpielLogoWhite.467fdfe71152876f1b23427b4e9f4838.svg";
export { ForwardRef as ReactComponent };